/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Hub_Search_PlaceholderInputs */

const cs_social_hub_search_placeholder = /** @type {(inputs: Social_Hub_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat nemovitosti…`)
};

const en_social_hub_search_placeholder = /** @type {(inputs: Social_Hub_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search properties…`)
};

/**
* | output |
* | --- |
* | "Search properties…" |
*
* @param {Social_Hub_Search_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_hub_search_placeholder = /** @type {((inputs?: Social_Hub_Search_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Hub_Search_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_hub_search_placeholder(inputs)
	return cs_social_hub_search_placeholder(inputs)
});